import React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../../../router/Routes';
import ContainerTemplate from '../../../../../widgets/template/Container';
import PanelEntHorarioClasesView from './AjustesEntHorarioClasesView';

const AjustesEntHorarioClasesModule = () => {
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );

  return (
    <ContainerTemplate
      active={ROUTES.entHorarioClasesAjustes}
      routes={[ROUTES.controlEstudios, ROUTES.horarios]}
      subtitle={entHorariosClasesStore.activo.nombre}
    >
      <PanelEntHorarioClasesView />
    </ContainerTemplate>
  );
};

export default AjustesEntHorarioClasesModule;
